import { apiClient } from './client';
import type { ApiResponse } from '@/types';
import type { User } from '@/store/user-store';

/**
 * Get current user details - authenticated endpoint
 */
export const getCurrentUserApi = async (): Promise<User> => {
  const response = await apiClient.get<ApiResponse<{ user: User }>>('/v1/user/me');
  return response.data.data.user;
};

export type Gender = 'MALE' | 'FEMALE' | 'OTHER';

export interface CompleteProfileRequest {
  fullName: string;
  phoneNumber: string;
  gender: Gender;
  dateOfBirth: string; // YYYY-MM-DD format
}

export interface CompleteProfileResponse {
  message: string;
  user: User;
}

/**
 * Complete user profile - authenticated endpoint
 */
export const completeProfileApi = async (
  data: CompleteProfileRequest
): Promise<CompleteProfileResponse> => {
  const response = await apiClient.post<ApiResponse<CompleteProfileResponse>>(
    '/v1/user/me/complete-profile',
    data
  );
  return response.data.data;
};
